import { render, staticRenderFns } from "./ScopeCard.vue?vue&type=template&id=505c2105&scoped=true&"
import script from "./ScopeCard.vue?vue&type=script&lang=ts&"
export * from "./ScopeCard.vue?vue&type=script&lang=ts&"
import style0 from "./ScopeCard.vue?vue&type=style&index=0&id=505c2105&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505c2105",
  null
  
)

export default component.exports